import React from 'react';

const ClientsSection = () => {
  const clients = [
    'reliance.webp',
    'indian_oil.webp',
    'shell.webp',
    'gail_india.webp',
    'opal.webp',
    'dow.webp',
    'exonboil.webp',
    'ineso.webp',
    'formosa.webp',
    'halida.webp',
    'mithubishi.webp',
    'tasnee.webp'
  ];

  return (
    <section className="clients-section">
      <div className="container">
        <div className="section-header">
          <h2>Brands We Deal</h2>
        </div>
        
        <div className="clients-scroll">
          <div className="clients-track">
            {clients.map((client, index) => (
              <div key={index} className="client-logo">
                <img 
                  src={`/assets/images/client_logo/${client}`} 
                  alt={client.replace('.webp', '').replace('_', ' ')} 
                  className="client-logo-img"
                />
              </div>
            ))}
            {clients.map((client, index) => (
              <div key={`duplicate-${index}`} className="client-logo">
                <img 
                  src={`/assets/images/client_logo/${client}`} 
                  alt={client.replace('.webp', '').replace('_', ' ')} 
                  className="client-logo-img"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;

